// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ab5898b3","190":"196bafe3","408":"81b99d8d","453":"6ea6ed3f","609":"962ccdea","610":"d57ed8c6","639":"494bc4b0","751":"93c7590f","973":"eb955629","995":"fc7756ea"}[chunkId] + ".chunk.js";
};